module.exports = __webpack_public_path__ + "img/id-verifing.40af3ee7.jpg";